/**
 * ClearRubricModal - Confirmation modal for clearing all rubrics
 */
import React, { useState } from 'react'
import { Modal, Button, Spinner } from 'react-bootstrap'

const ClearRubricModal = ({ show, onHide, onConfirm }) => {
  const [isClearing, setIsClearing] = useState(false)

  const handleConfirm = async () => {
    setIsClearing(true)
    await onConfirm()
    setIsClearing(false)
  }

  const handleClose = () => {
    if (!isClearing) {
      onHide()
    }
  }

  return (
    <Modal show={show} onHide={handleClose} centered backdrop={isClearing ? 'static' : true}>
      <Modal.Header closeButton={!isClearing}>
        <Modal.Title>Confirm Clear</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        Clearing the rubric will delete all criteria and reset existing rubric evaluations for all students. Are you sure you want to proceed?
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={isClearing}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm} disabled={isClearing}>
          {isClearing ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Clearing...
            </>
          ) : (
            'Yes, Clear'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ClearRubricModal
